import React, { Component } from 'react';

import { AttachmentApi } from 'services/attachment';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import { RESOLUTIONS } from 'services/config';
import { ModalHeader } from 'styled_components/Common/ModalHeader';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { TICKET_ATTACHMENT_PHASE as PHASE } from 'utils/TicketConstants';
import { AddAttachments } from 'styled_components/Common/AddAttachments';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const defaultUploadCloud = `${CDN_URL}common/upload-icon-default.svg`;

class AttachmentModal extends Component {
	constructor(props) {
		super(props);

		this.phase = null;
		this.state = {
			attachments: [],
			error: null,
			scannedAttachmentIds: [],
			erroredAttachmentIds: [],
			attachmentsComplete: false,
			phase: PHASE.NOT_STARTED,
		};
	}

	resetState = () => {
		this.setState({
			attachments: [],
			scannedAttachmentIds: [],
			erroredAttachmentIds: [],
			attachmentsComplete: false,
		});
	};

	onDrop = acceptedFiles => {
		this.setState({ error: null });

		acceptedFiles.forEach(file => {
			const reader = new FileReader();
			reader.onload = () => {
				const fileAsArrayBuffer = reader.result;
				const attachment = {
					filename: file.name,
					size: file.size,
					file: fileAsArrayBuffer,
					type: file.type,
				};
				if (AttachmentApi.isValidAttachmentType(attachment)) {
					this.setState(state => state.attachments.push(attachment));
				} else {
					this.setState(
						// eslint-disable-next-line
						state => (state.error = `Sorry, we do not support uploads of type ${attachment.type}`),
					);
				}
			};
			reader.onabort = () => console.log('file reading was aborted');
			reader.onerror = () => console.log('file reading has failed');

			reader.readAsArrayBuffer(file);
		});
	};

	checkFileAttachmentCompletion = (successes, errors, attachments) => {
		const { saveAttachments } = this.props;
		const { scannedAttachmentIds: existingAttachments } = this.state;

		if (successes.length + errors.length === attachments.length) {
			if (successes.length === 0 && errors.length > 0) {
				let err = '';

				errors.map(error => {
					return (err += `\n${error.filename} - ${error.error}`);
				});
				this.setState({ error: `Ticket upload failed.${err}` });
			} else if (successes.length > 0 || errors.length > 0) {
				setTimeout(() => {
					saveAttachments(successes, errors);
					this.setState({
						attachments: [],
						scannedAttachmentIds: existingAttachments.concat(successes),
						errorAttachmentIds: errors,
					});
				}, 2000);
			}
		}
	};

	toggleOpen = () => {
		const { toggle } = this.props;

		this.setState({ attachments: [], error: null }, toggle());
	};

	isStatePopulated = () => {
		const { attachments, scannedAttachmentIds, erroredAttachmentIds, attachmentsComplete } =
			this.state;

		return (
			attachments.length > 0 ||
			scannedAttachmentIds.length > 0 ||
			erroredAttachmentIds.length > 0 ||
			attachmentsComplete
		);
	};

	UNSAFE_componentWillUpdate() {
		const { phase } = this.props;
		const statePopulated = this.isStatePopulated();

		if (
			(phase === PHASE.TICKET_SUBMITTED && statePopulated) ||
			(phase === PHASE.NOT_STARTED && this.phase !== PHASE.NOT_STARTED)
		) {
			this.phase = phase;
			this.resetState();
		} else {
			this.phase = phase;
		}
	}

	componentDidMount() {
		const { attachments } = this.props;

		if (attachments) {
			this.setState({ attachments });
		}
	}
	componentDidUpdate(prevProps) {
		const { attachments } = this.props;
		const prevAttachments = prevProps?.attachments;

		if (attachments.length !== prevAttachments.length) {
			this.setState({ attachments });
		}
	}
	getSize = breakpoint => {
		let size = 'medium';
		if (breakpoint === RESOLUTIONS.MED) {
			size = 'medium';
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			size = 'medium';
		}

		return size;
	};

	render() {
		const { isOpen, breakpoint, auth_status, saveAttachments, attachments } = this.props;
		const { error, phase } = this.state;

		return (
			<PortraitModalComponent
				closeModal={this.toggleOpen}
				show={isOpen}
				header={<ModalHeader image={defaultUploadCloud} text={''} className='guest' />}
				title='UPLOAD FILES'
				subTitle={`Select files to upload`}
				size={this.getSize(breakpoint)}
				breakpoint={breakpoint}
			>
				<AddAttachments
					error={error}
					attachments={attachments}
					auth_status={auth_status}
					phase={phase}
					saveAttachments={saveAttachments}
				/>
				<ModalFooter
					cypressId='footer'
					id='footer'
					buttonText1='ATTACH'
					buttonText2='BROWSE'
					module='support'
					size={this.getSize(breakpoint)}
				/>
			</PortraitModalComponent>
		);
	}
}

export default AttachmentModal;
